import billingModule from '../../billing.module';
import template from './billingPaymentMethod.component.html';
import style from './billingPaymentMethod.component.scss';

export default billingModule.component('billingPaymentMethod', {
    template,
    style,
    controller(
        asLoadingMask,
        asNotifier,
        billingActionService,
        billingPaymentService,
        textResources,
        sessionService,
        sessionTypeConstants,
        $rootScope,
        billingOverviewEventConstants
    ) {
        var vm = this;

        vm.service = billingPaymentService;

        vm.$onInit = () => {
            vm.render();
        };

        vm.render = () => {
            vm.isRendering = true;

            var isGuestUser =
                sessionService.getSessionType() == sessionTypeConstants.guest;
            if (isGuestUser) {
                billingPaymentService
                    .getCurrentPaymentMethod(true)
                    .then(
                        () => {},
                        () => {
                            asNotifier.errorAndTryAgain(
                                textResources.billingGetPaymentMethodFailed
                            );
                        }
                    )
                    .finally(() => {
                        vm.isRendering = false;
                    });

                return;
            }

            billingActionService.hasAction('payment-method:create').then(
                hasAction => {
                    if (hasAction) {
                        vm.isRendering = false;
                    } else {
                        billingPaymentService
                            .getCurrentPaymentMethod()
                            .then(
                                () => {},
                                () => {
                                    asNotifier.errorAndTryAgain(
                                        textResources.billingGetPaymentMethodFailed
                                    );
                                }
                            )
                            .finally(() => {
                                vm.isRendering = false;
                            });
                    }
                },
                () => {
                    asNotifier.errorAndTryAgain(
                        textResources.billingGetPaymentMethodFailed
                    );
                    vm.isRendering = false;
                }
            );
        };

        vm.changePaymentMethodCallback = (success, result) => {
            invalidatePaymentMethod(success, result);
        };

        vm.addPaymentMethodCallback = (success, result) => {
            invalidatePaymentMethod(success, result, () => {
                vm.render();
            });
        };

        function invalidatePaymentMethod(
            success,
            result,
            invalidatedCallbackFn
        ) {
            if (success && result) {
                asLoadingMask.show();
                billingPaymentService
                    .updateCurrentPaymentMethod(result.paymentMethodId)
                    .finally(() => {
                        asLoadingMask.hide();

                        if (invalidatedCallbackFn !== undefined) {
                            invalidatedCallbackFn();
                        }

                        $rootScope.$broadcast(
                            billingOverviewEventConstants.paymentMethodUpdated
                        );
                    });
            }
        }
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-payment-method/billingPaymentMethod.component.js